<template>
  <div id="tabs">
    <div class="labels-wrapper">
      <div
        class="label"
        :class="{ active: activeTabItem.label === item.label }"
        v-for="(item, index) in tabs.filter(x => x.show !== false)"
        :key="index"
        @click="changeTab(item)"
      >
        {{ item.label }}
      </div>
    </div>
    <div class="content-wrapper">
      <transition name="fade" mode="out-in">
        <component
          :is="activeTabItem.component.bind.is"
          v-bind="activeTabItem.component.bind"
          v-on="activeTabItem.component.on"
        ></component>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  props: {
    tabs: {
      type: Array,
      required: true
    },
    activeTab: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      activeTabItem: undefined
    };
  },
  created() {
    this.$eventBus.onChangeTab(this, payload => {
      this.changeTab(this.tabs[payload]);
    });
    if (this.tabs.length > 0) {
      if (this.activeTab) {
        this.activeTabItem = this.tabs[this.activeTab];
      } else {
        this.activeTabItem = this.tabs[0];
      }
    }
  },
  methods: {
    changeTab(item) {
      this.activeTabItem = item;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#tabs {
  width: 100%;
  height: 100%;
  .labels-wrapper {
    display: flex;
    justify-content: center;
    padding: 10px;
    .label {
      font-size: 14px;
      cursor: pointer;
      color: inherit;
      transition: 0.3s all ease-in-out;
      width: fit-content;
      text-align: center;
      margin-right: 20px;
      margin-left: 20px;
      &:hover {
        color: $color-light-primary;
      }
      &.active {
        text-decoration: underline;
        font-size: 15px;
        font-weight: bold;
        color: $color-primary;
      }
    }
  }
  .content-wrapper {
  }
}
</style>
